(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("DecapCmsEditorComponentImage", ["react"], factory);
	else if(typeof exports === 'object')
		exports["DecapCmsEditorComponentImage"] = factory(require("react"));
	else
		root["DecapCmsEditorComponentImage"] = factory(root["React"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__119__) => {
return 